<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/NotificationsIcon.png" />
            <span class="title">{{ $t("admin.message_center.message_center_title") }}</span>

            <button :class="unreadButtonClass" v-on:click="handleUnreadButtonClicked()">{{ $t("admin.message_center.unread_button") }}</button>
            <button :class="emergencyButtonClass" v-on:click="handleEmergencyButtonClicked()">{{ $t("admin.message_center.emergency_button") }}</button>
            <button :class="terrainReportButtonClass" v-on:click="handleTerrainReportButtonClicked()">{{ $t("admin.message_center.terrain_report_button") }}</button>
            <button :class="allButtonClass" v-on:click="handleAllButtonClicked()">{{ $t("admin.message_center.all_button") }}</button>
            <button :class="trashButtonClass" v-on:click="handleTrashButtonClicked()">{{ $t("admin.message_center.trash_button") }}</button>
        </div>

        <div class="message-list-container shadow-sm">
            <ul class="message-list">
                <div class="empty-list" v-if="!messages || messages.length == 0">{{ $t("admin.message_center.no_messages_message") }}</div>
                <li class="message-container" v-for="message of messages" v-bind:key="message.id">
                    <div class="message-badges">
                        <span class="badge bg-primary" v-if="!message.read && !message.status">{{ $t("admin.message_center.unread_badge") }}</span>
                        <span class="badge bg-danger" v-if="message.type == 'emergency'">{{ $t("admin.message_center.emergency_badge") }}</span>
                        <span class="badge bg-warning" v-if="message.type == 'terrain_report'">{{ $t("admin.message_center.terrain_report_badge") }}</span>
                        <span class="badge bg-info" v-if="message.status == 'scheduled'">{{ $t("admin.message_center.scheduled_badge") }}</span>
                        <span class="badge bg-success" v-if="message.status == 'sent'">{{ $t("admin.message_center.sent_badge") }}</span>
                        <span class="badge bg-secondary" v-if="message.status == 'cancelled'">{{ $t("admin.message_center.cancelled_badge") }}</span>
                    </div>
                    <div class="message-icon">
                        <img src="@/assets/icons/EmergencyIcon.png" v-if="message.type == 'emergency'" />
                        <img src="@/assets/icons/TerrainReportIcon.png" v-if="message.type == 'terrain_report'" />
                        <img src="@/assets/icons/MessageIcon.png" v-if="message.type == 'message'" />
                    </div>
                    <div class="message-title">{{ messageTitle(message) }}</div>
                    <div class="message-received-on" v-if="message.receivedDate">{{ $t("admin.message_center.received_on") }} {{ messageReceivedDate(message) }}</div>
                    <div class="message-message">{{ messageMessage(message) }}</div>
                    <div class="message-actions">
                        <button class="btn btn-outline-primary btn-sm" v-if="(message.type == 'emergency' || message.type == 'terrain_report') && !message.deleted" v-on:click="handleViewOnMapClicked(message)">{{ $t("admin.message_center.view_on_map_button") }}</button>
                        <button class="btn btn-outline-primary btn-sm" v-if="canToggleReadStatus(message)" v-on:click="handleMarkAsReadButtonClicked(message)">{{ $t("admin.message_center.mark_as_read_button") }}</button>
                        <button class="btn btn-outline-primary btn-sm" v-if="canToggleUnreadStatus(message)" v-on:click="handleMarkAsUnreadButtonClicked(message)">{{ $t("admin.message_center.mark_as_unread_button") }}</button>
                        <button class="btn btn-outline-danger btn-sm" v-if="!message.deleted" v-on:click="handleDeleteButtonClicked(message)">{{ $t("admin.message_center.delete_button") }}</button>
                        <button class="btn btn-outline-primary btn-sm" v-if="message.deleted" v-on:click="handleRestoreButtonClicked(message)">{{ $t("admin.message_center.restore_button") }}</button>
                    </div>
                    <hr />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import MessagingService from "@/service/MessagingService.js"
import LangUtils from "@/utils/LangUtils.js"
import * as moment from 'moment';

export default {
    data() {
        return {
            messagingService: new MessagingService(),
            selectedPublisher: this.$store.state.currentPublisher,
            currentUser: this.$store.state.currentUser,
            selectedToolbarButtonId: "unread",
            messages: null,
        }
    },

    computed: {
        allButtonClass() {
            return "btn btn-outline-secondary btn-sm" + (this.selectedToolbarButtonId == "all" ? " active": "");
        },

        unreadButtonClass() {
            return "btn btn-outline-secondary btn-sm" + (this.selectedToolbarButtonId == "unread" ? " active": "");
        },

        emergencyButtonClass() {
            return "btn btn-outline-danger btn-sm" + (this.selectedToolbarButtonId == "emergency" ? " active": "");
        },

        terrainReportButtonClass() {
            return "btn btn-outline-warning btn-sm" + (this.selectedToolbarButtonId == "terrainReport" ? " active": "");
        },
        
        allInboxButtonClass() {
            return "btn btn-outline-secondary btn-sm" + (this.selectedToolbarButtonId == "inboxAll" ? " active": "");
        },

        trashButtonClass() {
            return "btn btn-outline-secondary btn-sm" + (this.selectedToolbarButtonId == "trash" ? " active": "");
        },
    },

    methods: {
        loadMessages() {
            if (this.selectedPublisher && this.currentUser) {
                this.messagingService.loadMessagesForUser(this.currentUser.uid, this.selectedPublisher.id, false,
                    this.selectedToolbarButtonId == "unread", this.selectedToolbarButtonId == "trash", false).then((messages) => {
                        if (this.selectedToolbarButtonId == "emergency") {
                            const filteredMessages = [];
                            for (const message of messages) {
                                if (message.type == 'emergency') {
                                    filteredMessages.push(message);
                                }
                            }
                            this.messages = filteredMessages;
                        } else if (this.selectedToolbarButtonId == "terrainReport") {
                            const filteredMessages = [];
                            for (const message of messages) {
                                if (message.type == 'terrain_report') {
                                    filteredMessages.push(message);
                                }
                            }
                            this.messages = filteredMessages;
                        } else {
                            this.messages = messages;
                        }
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        messageTitle(message) {
            return LangUtils.valueForLanguage(message.getTitle(), this.$i18n.locale)
        },

        messageMessage(message) {
            return LangUtils.valueForLanguage(message.getMessage(), this.$i18n.locale)
        },

        messageReceivedDate(message) {
            return LangUtils.valueForLanguage(
                moment(new Date(message.getReceivedDate())).format("YYYY-MM-DD hh:mm"), this.$i18n.locale);
        },

        handleInboxButtonClicked() {
            this.selectedToolbarButtonId = "unread";
            this.loadMessages();
        },

        handleOutboxButtonClicked() {
            this.selectedToolbarButtonId = "scheduled";
            this.loadMessages();
        },

        handleUnreadButtonClicked() {
            this.selectedToolbarButtonId = "unread";
            this.loadMessages();
        },

        handleAllButtonClicked() {
            this.selectedToolbarButtonId = "all";
            this.loadMessages();
        },

        handleScheduledButtonClicked() {
            this.selectedToolbarButtonId = "scheduled";
            this.loadMessages();
        },

        handleSentButtonClicked() {
            this.selectedToolbarButtonId = "sent";
            this.loadMessages();
        },

        handleCancelledButtonClicked() {
            this.selectedToolbarButtonId = "cancelled";
            this.loadMessages();
        },

        handleTrashButtonClicked() {
            this.selectedToolbarButtonId = "trash";
            this.loadMessages();
        },

        handleEmergencyButtonClicked() {
            this.selectedToolbarButtonId = "emergency";
            this.loadMessages();
        },

        handleTerrainReportButtonClicked() {
            this.selectedToolbarButtonId = "terrainReport";
            this.loadMessages();
        },

        handleAllInboxButtonClicked() {
            this.selectedToolbarButtonId = "inboxAll";
            this.loadMessages();
        },

        canToggleReadStatus(message) {
            return this.messages && this.messages.indexOf(message) > -1 && !message.read && !message.deleted;
        },

        canToggleUnreadStatus(message) {
            return this.messages && this.messages.indexOf(message) > -1 && message.read && !message.deleted;
        },

        handleMarkAsReadButtonClicked(message) {
            message.read = true;

            this.messagingService.saveMessageForUser(this.currentUser.uid, message).then(() => {
                if (this.selectedToolbarButtonId == "unread") {
                    this.loadMessages();
                }
            });
        },

        handleMarkAsUnreadButtonClicked(message) {
            message.read = false;

            this.messagingService.saveMessageForUser(this.currentUser.uid, message);
        },

        handleDeleteButtonClicked(message) {
            message.deleted = true;

            this.messagingService.saveMessageForUser(this.currentUser.uid, message).then(() => {
                this.loadMessages();
            }).catch((error) => {
                // TODO handle error.
                console.log(error);
            });
        },

        handleRestoreButtonClicked(message) {
            message.deleted = false;

            this.messagingService.saveMessageForUser(this.currentUser.uid, message).then(() => {
                this.loadMessages();
            }).catch((error) => {
                // TODO handle error.
                console.log(error);
            });
        },

        handleViewOnMapClicked(message) {
            if (message && message.getActionUrl()) {
                this.$router.push(message.getActionUrl());
            }
        }
    },

    mounted() {
        this.$store.subscribe( (mutation) => {
            if (mutation.type == "setCurrentPublisher") {
                this.selectedPublisher = mutation.payload;
                this.loadMessages();
            }
        });

        this.loadMessages();
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    width: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.empty-list {
    color: #777777;
    font-size: 36px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}

.message-list-container {
    background-color: #ffffff;
    margin: 0 auto;
    overflow: scroll;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;
}

.message-list {
    list-style-type: none;
    padding: 0px;
    margin-top: 24px;
}

.message-container {
    display: grid;
    grid-template-columns: 50px auto 400px;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: "icon badges badges" "icon received-on-scheduled-on received-on-scheduled-on" "icon title actions" ". message actions" "separator separator separator";
}

.message-badges {
    grid-area: badges;
}

.message-badges span {
    margin-right: 8px;
}

.message-icon {
    grid-area: icon;
}

.message-icon img {
    width: 40px;
}

.message-title {
    grid-area: title;
    font-weight: bold;
}

.message-received-on {
    grid-area: received-on-scheduled-on;
    color: #999999;
    font-size: 14px;
}

.message-scheduled-on {
    grid-area: received-on-scheduled-on;
    color: #999999;
    font-size: 14px;
}

.message-message {
    grid-area: message;
    color: #555555;
}

.message-actions {
    grid-area: actions;
    text-align: right;
}

.message-actions button {
    margin: 4px 4px;
}

.message-container hr {
    grid-area: separator;
}

.scheduled-on-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}

</style>
